export const inputDefaultStyle = " text-[14px] text-[#919499] font-normal block  w-full rounded-[14px] border-[1.3px]  border-[#C4C4C480] h-[65px]  pl-8 transition  "
export const inputFocuseStyle = "focus:border-black   focus:outline-none"
export const inputLabelStyle = "text-[14px] text-[#919499] font-medium "


export const buttonStyle = "text-[15px] text-white font-semibold inline-block rounded-[14px]  w-full  h-[65px]   "
